import { PurchasesListProps } from './purchases-list.props';

export const PurchasesListPresets: Partial<PurchasesListProps> = {
  products: [],
};
